import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import DiagnosePage from "@/pages/DiagnosePage";
import MechanicsPage from "@/pages/MechanicsPage";
import TowTrucksPage from "@/pages/TowTrucksPage";
import HistoryPage from "@/pages/HistoryPage";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<DiagnosePage />} />
            <Route path="mechanics" element={<MechanicsPage />} />
            <Route path="tow-trucks" element={<TowTrucksPage />} />
            <Route path="history" element={<HistoryPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#161E2E",
            border: "1px solid #374151",
            color: "#F9FAFB",
          },
        }}
      />
    </div>
  );
}

export default App;
